module.exports = __webpack_public_path__ + "static/media/intro_book.64f0c7c9.TTF";